// Every rule number in this file cites its source. Two editions of For Sale
// are in circulation with genuinely different numbers; this implements the
// Überplay/Gryphon English edition, the one the card art comes from. Read
// docs/RULES_SOURCES.md before "fixing" any number here - the IELLO PDF in
// docs/ disagrees with several of them on purpose.
//
// Citations: "IELLO p<n>" is docs/rulebook-iello.pdf (rules common to both
// editions); "Gryphon" is the cross-checked transcription pair listed in
// docs/RULES_SOURCES.md (numbers specific to that edition).

/** IELLO p2 CONTENT: "30 House cards numbered from 1 to 30." */
export const PROPERTY_COUNT = 30;

/**
 * IELLO p2 CONTENT: "30 Cheque Cards: 14 numbered 2 to 15 (two copies of
 * each), as well as 2 of value 0". Values are in thousands of dollars, and
 * note the hole: there is no $1,000 cheque.
 */
export const CHEQUE_VALUES = [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
export const COPIES_PER_CHEQUE = 2;

/** Box and both rulebooks: 3-6 players. */
export const MIN_PLAYERS = 3;
export const MAX_PLAYERS = 6;

/**
 * Gryphon: 3-4 players start with $18,000, 5-6 players with $14,000
 * (physically dealt as two $2,000 coins plus $1,000 coins). All money is
 * tracked in whole thousands; there is no sub-thousand amount anywhere in
 * the game.
 */
export const STARTING_COINS_BY_COUNT = { 3: 18, 4: 18, 5: 14, 6: 14 };

/**
 * Gryphon: with 3 players remove 6 property and 6 cheque cards unseen; with
 * 4 players remove 2 and 2. This is what makes both phases come out even:
 * every auction round flips exactly one card per player, so the deck must
 * divide by the player count (24/3, 28/4, 30/5, 30/6).
 */
export const CARDS_REMOVED_BY_COUNT = { 3: 6, 4: 2, 5: 0, 6: 0 };

/**
 * Gryphon: a passing player "takes back half of your previously bid money
 * (rounded down)"; the worked example bids $3,000 and takes back $1,000.
 * In thousands: refund = floor(bid/2), forfeit = ceil(bid/2).
 *
 * (This is the sharpest difference from the IELLO edition, which rounds the
 * REFUND up. See docs/RULES_SOURCES.md.)
 */
export const passRefund = (bid) => Math.floor(bid / 2);
export const passCost = (bid) => Math.ceil(bid / 2);

export const PHASES = {
  /** Phase 1, IELLO p3: "Buying houses" - turn-based bidding rounds. */
  BUYING: 'buying',
  /** Phase 2, IELLO p5: "Sale of houses" - simultaneous secret picks. */
  SELLING: 'selling',
  /** IELLO p7: all cheques distributed. */
  FINISHED: 'finished',
};

/** What a player did on their bidding turn. IELLO p3: "Bid Or Spend". */
export const BID_ACTIONS = {
  BID: 'bid',
  PASS: 'pass',
};
